// Turns a hex recipe (public/models/capital/hex_recipes.json) into a flat part list.
// Fixed parts pass through. A {"scatter": …} entry is expanded with a seeded random generator, so every
// hex gets its OWN layout (poles, heights, rotations) that never changes between loads for that tile.
//
//   w = width factor (thinner < 1) applied to x/z only, so tall things can be slim.
//   { "scatter": { "p": "Prop_Bamboo_Pole", "n": [60, 90], "radius": 5.7, "s": [1.2, 2.0], "w": 0.6, "minD": 0.6 } }

function hashSeed(str) {
  let h = 1779033703 ^ str.length
  for (let i = 0; i < str.length; i++) { h = Math.imul(h ^ str.charCodeAt(i), 3432918353); h = (h << 13) | (h >>> 19) }
  return h >>> 0
}
function rng(seed) {
  let a = hashSeed(String(seed))
  return () => { a |= 0; a = (a + 0x6d2b79f5) | 0; let t = Math.imul(a ^ (a >>> 15), 1 | a); t = (t + Math.imul(t ^ (t >>> 7), 61 | t)) ^ t; return ((t ^ (t >>> 14)) >>> 0) / 4294967296 }
}

export function expandRecipe(recipe, seed) {
  const rnd = rng(`${seed}`)
  const range = (v, def) => (Array.isArray(v) ? v[0] + rnd() * (v[1] - v[0]) : (v ?? def))
  const out = []
  for (const part of recipe.parts) {
    if (!part.scatter) { out.push(part); continue }
    const c = part.scatter
    const n = Math.round(range(c.n, 10))
    const placed = []
    for (let t = 0; placed.length < n && t < n * 60; t++) {
      const a = rnd() * Math.PI * 2
      const r = (c.radius ?? 5) * Math.sqrt(rnd())
      const x = r * Math.cos(a), z = r * Math.sin(a)
      if (c.minD && placed.some((q) => (q.x - x) ** 2 + (q.z - z) ** 2 < c.minD * c.minD)) continue
      placed.push({ p: c.p, x: +x.toFixed(2), z: +z.toFixed(2), y: 0, r: Math.round(rnd() * 360), s: +range(c.s, 1).toFixed(2), w: c.w ?? 1 })
    }
    out.push(...placed)
  }
  return out
}
